module.exports = __webpack_public_path__ + "Roboto-Regular.2751ee43015f9884c364.woff2";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Regular.woff2
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Regular.woff2
// module chunks = styles